module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/registration.component.css
// module id = ./src/app/registration/registration.component.css
// module chunks = main